import { ChartArea } from 'lucide-react'
import { RequestsPerMinuteChartFallback } from '@/components/shared/analytics/charts/requests-per-minute-chart/fallback'
import { ResponseTimeChartFallback } from '@/components/shared/analytics/charts/response-time-chart/fallback'
import { TopCountriesTableFallback } from '@/components/shared/analytics/charts/top-countries-table/fallback'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

export const LoadBalancerChartsFallback = () => {
  return (
    <div className="space-y-6">
      <Card className="bg-secondary p-0 gap-0">
        <CardHeader className="px-5 pt-3 pb-1">
          <CardTitle>
            <H3 className="flex items-center gap-2 text-sm">
              <ChartArea className="size-4" /> Analytics
            </H3>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Card className="p-0 border-x-0 border-b-0 shadow-none">
            <CardContent className="p-0 pb-6 space-y-6">
              <div className="pb-0 p-6">
                <div className="flex items-center gap-4">
                  <Skeleton className="h-4 w-9" />
                  <Skeleton className="h-9 w-70.5" />
                </div>
              </div>
              <Separator className="w-full" />
              <TopCountriesTableFallback />
              <Separator className="w-full mt-6" />
              <RequestsPerMinuteChartFallback />
              <Separator className="w-full mt-6" />
              <ResponseTimeChartFallback />
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </div>
  )
}
